import {mixin} from "@/helpers/helper";
export default {
    namespaced: true,
    state: {
        walletTotal: '',
        movements: null,
        bread_active: null,
        bread_list: null,
        user: 0,
    },
    getters: {},
    mutations: {
        SET_DATA: function (state, data) {
            eval(`state.${data.name} = data.data`);
        }
    },
    actions: {

        walletMovements(state){
            axios.get('/api/v2/wallet/movements')
                .then(response =>{
                    state.commit('SET_DATA', {
                        name: 'movements', data: response.data
                    });
                })
        },

        myWallet(state) {

            axios.get('/api/v2/wallet/total/')
                .then(response => {

                    state.commit('SET_DATA', {
                        name: 'walletTotal', data: response.data.walletTotal
                    });

                    state.commit('SET_DATA', {
                        name: 'user', data: response.data.user
                    });

                })
                .catch(error => {
                    if (error.response.status === 401) {
                        window.location.href = '/login?msg=session_expired';
                    }

                })
        }
    }
}
